import { render, staticRenderFns } from "./attestReportList.vue?vue&type=template&id=2cb3814d&scoped=true"
import script from "./attestReportList.vue?vue&type=script&lang=js"
export * from "./attestReportList.vue?vue&type=script&lang=js"
import style0 from "./attestReportList.vue?vue&type=style&index=0&id=2cb3814d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3814d",
  null
  
)

export default component.exports